var map = {
	"./bel9850/loader.gif": "kXwN",
	"./lekkerhot/loader.gif": "Yi1G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l8cn";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/loader\.gif$
// module id = l8cn
// module chunks = 0